var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[(!_vm.isScrolledDown)?_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs,"truncateTo":35}}):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.title))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }